<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19RvTTf/tc-custom/9780312871468.jpg?1728724831252" alt="This image is the cover for the book Book of Knights"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Book of Knights
      </h1>
      <p class="bookDescription body article font2">
        <p>A fantasy novel about a young boy who discoves a wonderful book that fills him with the desire to grow up to be  knight--and whose desire is granted in strange and unexpected ways.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yves Meynard
      </h2>
      
      <p class="authorDescription body article"><P><B>Yves Meynard</B> lives in Longueuil, Quebec. He is the literary editor of the SF magazine <I>Solaris</I>, and has published several books in French.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?413dcfb4